import React from 'react';

const ImageBand = ({ description, content }) => {
  return (
    <div className="d-flex flex-column justify-content-center mt-25 mb-15">
      {/* <p className="line-one">{description}</p> */}
      <div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default ImageBand;
